import NotificationCentre from "./NotificationCentre";

export default NotificationCentre